import { useCallback } from 'react';
import { parseFileToSheet, sheetToGrid, guessAddressField } from 'features/geocoder/utils/xlsxUtils';
import { parseShapefileZip, geojsonToGrid } from 'features/geocoder/utils/shpUtils';
import { useGeoCodingContext } from '../context/GeoCodingContext';

export default function useFileReader() {
    const {
        setGridColumns,
        setGridRows,
        setSheetAddrOpts,
        setSheetAddrField,
        setFileReadError,
    } = useGeoCodingContext();

    /**
     * 파일을 파싱하여 상태를 세팅
     * @param {File} file
     * @param {string} encoding 'UTF-8' | 'EUC-KR' ...
     */
    const read = useCallback(async (file, encoding = 'UTF-8') => {
        if (!file) return;
        try {
            setFileReadError(null);
            // 1) 워크시트 파싱
            const worksheet = await parseFileToSheet(file, encoding);

            // 2) Grid 데이터로 변환
            const { columns: cols, rows: rws } = sheetToGrid(worksheet);
            
            if (rws?.length === 0) {
                alert("올바르지 않은 형식의 파일입니다.")
                return;
            }
            
            // 3) 상태 세팅
            setGridColumns(cols);
            setGridRows(rws);

            // 4) 주소 필드 옵션/기본값
            setSheetAddrOpts(cols);
            setSheetAddrField(guessAddressField(cols));
        } catch (err) {
            console.error('[useFileReader.read] parse error:', err);
            setFileReadError(err?.message || '파일을 읽는 중 오류가 발생했습니다.');
            // 실패 시 상태 초기화
            setGridColumns([]);
            setGridRows([]);
            setSheetAddrOpts([]);
            setSheetAddrField(null);
        }
    }, []);

    // 데이터 초기화
    const clearState = useCallback(() => {
        setGridColumns([]);
        setGridRows([]);
        setSheetAddrOpts([]);
        setSheetAddrField(null);
        setFileReadError(null);
    }, [setGridColumns, setGridRows, setSheetAddrOpts, setSheetAddrField, setFileReadError]);

    return {
        read,
        clearState,
    };
}

export async function readShapefile(file, setters) {
    const gj = await parseShapefileZip(file);
    const { columns, rows } = geojsonToGrid(gj);
    setters.setGridColumns(columns);
    setters.setGridRows(rows);
    setters.setShapeAddrOpts(columns);
    setters.setShapeAddrField(columns[0]);
    return gj;
}
